import { convertDateToBE } from "@relode/core";
import { HiredCandidate } from "../../types";
import { HireRequest } from "../controllers/candidates";

export const convertHireRequest = (hiredCandidate: HiredCandidate) => {
    const request: HireRequest = {
        candidateConcurrencyToken: hiredCandidate.candidateConcurrencyToken,
        endDate: convertDateToBE(hiredCandidate.hiredEndDate),
        hoursPerWeek: hiredCandidate.hiredHoursPerWeek,
        jobSalaryTypeId: hiredCandidate.hiredJobSalaryTypeId,
        startDate: convertDateToBE(hiredCandidate.hiredStartDate),
        jobSalaryInUSDollars: hiredCandidate.hiredJobSalaryInUSDollars,
    };

    return request;
};
